import useFocusRestoration from './useFocusRestoration'

export default useFocusRestoration
